import { Button } from '@mui/material';
import { useState } from 'react';
import { TrimmedCompany } from '../../api/api-types';
import HardwareCreatorDialog from './HardwareCreatorDialog';

interface Props {
  company?: TrimmedCompany;
}

const HardwareManagementButton = ({ company }: Props) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const openDialog = () => {
    setDialogOpen(true);
  };
  return (
    <>
      <Button onClick={openDialog} variant='outlined'>
        Add Hardware
      </Button>
      <HardwareCreatorDialog
        addHardwareOpen={dialogOpen}
        setAddHardwareOpen={setDialogOpen}
        company={company}
      />
    </>
  );
};

export default HardwareManagementButton;
